import api from '../..'

const orderFolder = (id: number, target: number) => {
  return api.patch(`/administration/folders/${id}/order/${target}'`)
}

export default orderFolder
